import ProductImageUrl, { ProductImageUrlInitializer } from './ProductImageUrl';

export enum MerchantProductStatus {
  Unpublished = 'unpublished',
  NotForSale = 'not_for_sale',
  Accepting = 'accepting',
}

export interface ProductInitializer {
  publicId: number;
  merchantId: number;
  scheme: number;
  name: string;
  imageUrl: ProductImageUrlInitializer;
  description: string;
  price: number;
  ticketCount: number;
  expiration: number;
  publishedAt: string;
}

export default class Product {
  public readonly publicId: number;
  public readonly merchantId: number;
  public readonly scheme: number;
  public readonly name: string;
  public readonly imageUrl: ProductImageUrl;
  public readonly description: string;
  public readonly price: number;
  public readonly ticketCount: number;
  public readonly expiration: number;
  public readonly publishedAt: string;

  constructor(init: ProductInitializer) {
    this.publicId = init.publicId;
    this.merchantId = init.merchantId;
    this.scheme = init.scheme;
    this.name = init.name;
    this.imageUrl = init.imageUrl;
    this.description = init.description;
    this.price = init.price;
    this.ticketCount = init.ticketCount;
    this.expiration = init.expiration;
    this.publishedAt = init.publishedAt;
  }
}
